import { restoreComplete } from '../../../../../../../api/auth/restore-request';
import { useTranslation } from '../../../../../../../i18n/use-translation';
import { useNotification } from '../../../../../../hooks/use-notification';
import { useRequest } from '../../../../../../hooks/use-request';

type Params = {
  onSuccess: () => void;
  phone: string;
};

export function useViewModel(params: Params) {
  const { successNotification } = useNotification();
  const { isLoading, action } = useRequest();
  const { t } = useTranslation();

  const submitHandler = async (data: { password: string; passwordConfirm: string; code: string }) =>
    action(async () => {
      const resp = await restoreComplete(data.code, data.password, params.phone);
      if (!resp.success) {
        throw new Error(resp);
      }

      successNotification(t('password_restored'));
      params.onSuccess();
    });

  return { submitHandler, isLoading };
}
